import axios from "./../../utils/axios";
// all
// saved
export const getPosts = async (filter) => {
  console.log(filter);
    let query = "";
    if (filter?.sortBy === "default") {
      query += `_sort=id&_order=asc&`;
    } else if (filter?.sortBy === "newest") {
      query += `_sort=id&_order=desc&`;
    } else if (filter?.sortBy === "most_liked") {
      query += `_sort=likes&_order=desc&`;
    }
    if (filter?.status === "saved") {
      query += `isSaved=true`;
    }
  const response = await axios.get(`/blogs?${query}`);
  return response.data;
};

